;Language = function(startLanguage) {

  // Translate
  $( 'body' ).addClass( 'pt' );

  $( '[language]' ).on( 'click', function( e ) {
    var language = $( e.currentTarget ).attr( 'language' );
    $( this ).addClass( 'active' );
    changeLanguage( language );
  });

  function changeLanguage( language ) {
    $( 'body' ).removeClass( 'pt en' ).addClass( language );
    $( '[language]' ).removeClass( 'active' );
    $( '#lang-' + language ).addClass( 'active' );
    localStorage.setItem( 'language', language );
    $( 'body' ).trigger( 'lang-change', language );
  };

  // Local storage
  var language = localStorage.getItem( 'language' );
  if ( !language ) {
    language = 'pt';
  }
  changeLanguage( language );

};


